<template>
    <div v-if="projID && proj" class="animated fadeIn">
        <!-- 封面區域 -->
        <div class="cover-bg" :style="$tools.style.imgCover($config.checkURL('pic',proj.pic))">
            <b-row class="proj-cover body-top-full justify-content-md-center" align-v="center">
                <b-col md="5" class="text-center">
                    <div class="proj-logo-area">
                        <h1 v-text="proj.name"></h1>
                        <!-- <h3 v-text="$t('menu.project_summary')"></h3> -->
                        <div class="mb-2">
                            <i class="fa fa-calendar block-text"></i>
                            <div class="block-text">{{ $t('menu.start_date') }}:</div>
                            <div class="block-text">{{ proj.start_date }}</div>
                            <div class="block-text">( {{ proj.count_projectDays + ' '  + $t('u.days') }} )</div>
                        </div>
                    </div>

                </b-col>

            </b-row>
        </div>

        <!-- 專案資訊 -->
        <div class="container-fluid">

            <div class="info-block">
                <b-btn class="m-1 header-align-btn" variant="success" aria-controls="collapse_pi"
                    @click="collapse_pi = !collapse_pi" :class="collapse_pi ? 'collapsed' : null"
                    :aria-expanded="collapse_pi ? 'true' : 'false'">
                    {{ $t('menu.project_information') }}
                    <i :class="$tools.style.classToggle(collapse_pi)"></i>
                </b-btn>
                <!-- 服務等級 -->
                <div :class="$tools.style.classServiceLevel(proj.service_level) + ' block-service-level'">
                    <i class="fa fa-shield"></i> {{ $t('status.service_level.' + proj.service_level ) }}
                </div>

                <b-collapse id="collapse_pi" v-model="collapse_pi" class="header-align-collapse">
                    <b-card>
                        <b-row align-v="center">
                            <b-col md="3">

                                <div class="mb-2">
                                    <!-- 專案 logo -->
                                    <!-- <div class="project-name-desc block-sm" v-text="proj.name"></div> -->
                                    <img v-if="proj.logo" :src="$config.checkURL('pic', proj.logo)"
                                        :alt="proj.name + ' logo'" class="proj-logo block-sm">
                                    <div v-else class="proj-logo-empty block-sm">
                                        <b-row align-v="center" style="height:100%;">
                                            <b-col>{{ proj.name }} logo</b-col>
                                        </b-row>
                                    </div>
                                </div>

                            </b-col>
                            <b-col md="9">

                                <div>
                                    <!-- 開始日期 -->
                                    <div class="block-md agri-color">
                                        <i class="fa fa-calendar block-text"></i>
                                        <div class="block-text">{{ $t('menu.start_date') }}:</div>
                                        <div class="block-text">{{ proj.start_date }}</div>
                                        <div class="block-text" v-if="proj.end_date"> - {{ proj.end_date }}</div>
                                        <div class="block-text">( {{ proj.count_projectDays + ' '  + $t('u.days') }} )
                                        </div>
                                    </div>
                                    <!-- 專案到期日期 -->
                                    <div :class="'block-md agri-color ' + style_Expiry(proj)" v-if="proj.end_date">
                                        <i class="fa fa-quote-left block-text"></i>
                                        <div class="block-text">{{ $t('menu.expiry_date') }}:</div>
                                        <div class="block-text">{{ proj.end_date }}</div>
                                    </div>
                                    <!-- 時區 -->
                                    <div class="block-md agri-color">
                                        <i class="fa fa-clock-o block-text"></i>
                                        <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                        <div class="block-text">{{ proj.timezone }}</div>
                                    </div>
                                    <!-- 參與者 -->
                                    <div class="block-md agri-color">
                                        <i class="icon-people block-text"></i>
                                        <div class="block-text" id="title-members">{{ $t('menu.participants') }}:</div>
                                        <div class="block-text member-count">{{ proj.members }}</div>
                                        <div v-if="project_editable || user_admin" class="block-text">
                                            <div v-if="project_members">
                                                <template v-for="(member, idx_m) in project_members">
                                                    <!-- Admin 才會秀出 admin 名單 -->
                                                    <template v-if="member.is_admin || member.role == 'beehive'">
                                                        <div v-if="user_admin" class="block-text member-admin"
                                                            :key="idx_m">
                                                            <i :class="$tools.style.classRoleIcon(member.role)"></i>
                                                            {{ member.first_name }} {{ member.last_name }}
                                                        </div>
                                                    </template>
                                                    <!-- 非 Admin 成員 -->
                                                    <div :key="idx_m" v-else class="block-text member-normal">
                                                        <i :class="$tools.style.classRoleIcon(member.role)"></i>
                                                        {{ member.first_name }} {{ member.last_name }}
                                                    </div>
                                                </template>
                                                <b-tooltip target="title-members" placement="right">
                                                    <div class="member-tooltip"><i
                                                            :class="$tools.style.classRoleIcon('project_owner')"></i>{{ $t('n.project_owner') }}
                                                    </div>
                                                    <div class="member-tooltip"><i
                                                            :class="$tools.style.classRoleIcon('project_member')"></i>{{ $t('n.project_member') }}
                                                    </div>
                                                    <div class="member-tooltip"><i
                                                            :class="$tools.style.classRoleIcon('researcher')"></i>{{ $t('n.researcher') }}
                                                    </div>
                                                    <div class="member-tooltip" v-if="user_admin"><i
                                                            :class="$tools.style.classRoleIcon('beehive')"></i>{{ $t('n.beehive') }}
                                                    </div>
                                                </b-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <!-- 面積 -->
                                <div class="block-md agri-color">
                                    <div class="block-text">
                                        <UnitConvertorArea :area="proj.area" defaultUnit="m2" :timezone="proj.timezone"
                                            pageType="project" selectorType="dropdown"></UnitConvertorArea>
                                    </div>
                                </div>
                                <!-- 地區、地址 -->
                                <div class="block-md agri-color">
                                    <i class="icon-location-pin block-text"></i>
                                    <div class="block-text">{{ $t('menu.location') }}:</div>
                                    <div class="block-text">{{ proj.location }}</div>
                                    <div class="block-text">({{ proj.address }})</div>
                                </div>

                            </b-col>
                        </b-row>

                        <!-- <h4 class="header-sub" v-text="$t('menu.project_information')"></h4> -->
                        <p v-if="proj.description" class="card-text">{{ proj.description }}</p>

                        <!-- Admin 備註 -->
                        <div v-if="user_admin" class="block-text">

                            <b-alert v-if="proj.note" variant="secondary" show>
                                <div class="block-text-sm"><i class="icon-menu"></i>{{ $t('menu.admin_note') }}：</div>
                                <div v-html="proj.note" class="block-sm"></div>
                            </b-alert>

                        </div>

                        <b-row>
                            <b-col md=6>

                                 <!-- 頁面按鈕 -->
                                <div class="card-subtitle mb-2">
                                    <b-button class="btn btn-cp" :to="{ name: 'AgriDiary', params: { projectID: proj.id } }">
                                        <i class="fa fa-book"></i>{{ $t('menu.agridiary') }}
                                    </b-button>

                                    <b-button class="btn btn-cp" :to="{ name: 'Project History', params: { projectID: proj.id } }">
                                        <i class="fa fa-history"></i>{{ $t('menu.history') }}
                                    </b-button>

                                    <b-button class="btn btn-cp" :to="{ name: 'Reports', params: { projectID: proj.id } }">
                                        <i class="fa fa-line-chart"></i>{{ $t('menu.agri_science_reports') }}
                                    </b-button>
                                </div>

                            </b-col>
                            <b-col md=6>
                                <div class="text-right mb-2">

                                    <div class="d-inline-block text-left">

                                        <LineNotifyButton
                                            :projectID="proj.id"
                                            v-if="showLineNotifyButton"
                                            :editable="project_editable || user_admin"
                                            :timezone="proj.timezone"
                                        ></LineNotifyButton>

                                        <ControlWebsiteButton
                                            :projectID="proj.id"
                                            :timezone="proj.timezone"
                                        ></ControlWebsiteButton>

                                    </div>

                                </div>
                            </b-col>
                        </b-row>

                        <div v-if="proj.editable">
                            <hr>
                            <h5 class="block-text">{{ $t('menu.management') }}</h5>
                            <div class="block-text">
                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Project Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.project_management') }}
                                </b-button>

                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Cropperiod Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.cropping_season_management') }}
                                </b-button>

                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Device Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.device_management') }}
                                </b-button>

                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Custom Alert Rule Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.custom_alert_rule_management') }}
                                </b-button>
                            </div>
                        </div>

                    </b-card>
                </b-collapse>
            </div>
        </div>

        <!-- 場域架構圖 -->
        <ProjectMap></ProjectMap>

        <!-- 期作資訊：進行中 -->
        <div class="container-fluid area-cropperiod">
            <CropPeriods></CropPeriods>
        </div>


        <!-- 期作資訊：已完成 -->
        <div class="container-fluid area-cropperiod">
            <CropPeriodsFinished></CropPeriodsFinished>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ProjectMap from './ProjectMap'
    import CropPeriods from './crop/CropPeriods'
    import CropPeriodsFinished from './crop/CropPeriodsFinished'
    import UnitConvertorArea from '@/views/components/UnitConvertor_Area'
    import LineNotifyButton from '@/views/project/app/LineNotify_Button'
    import ControlWebsiteButton from '@/views/project/app/ControlWebsite_Button'

    export default {
        name: 'projectSummary',
        data: function () {
            return {
                collapse_pi: true,
            }
        },
        components: {
            ProjectMap,
            CropPeriods,
            CropPeriodsFinished,
            UnitConvertorArea,
            LineNotifyButton,
            ControlWebsiteButton,
        },
        mounted ()
        {
            // 取得專案 detail 後撈取地圖需要資訊
            this.getProjectDevices( this.projID );

            if (this.project_editable || this.user_admin) {
                this.getProjectMembers( this.projID );
            }
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'project_detail': state => state.project.project_detail,
                'project_members': state => state.project.project_members,
                'project_editable': state => state.project.project_editable,
            }),

            proj() {
                return this.project_detail
            },

            projID() {
                return this.$route.params.projectID;
            },

            showLineNotifyButton ()
            {
                if (this.project_detail == undefined) return false

                return true
            },
        },
        watch: {

            projID (val, oldVal)
            {
                if ( val )
                {
                    // 取得專案 detail 後撈取地圖需要資訊
                    this.getProjectDevices(val);

                    if (this.project_editable || this.user_admin) {
                        this.getProjectMembers(val);
                    }
                }
            },
        },
        methods: {

            style_Expiry (projInfo)
            {
                let _class = 'expiry-date'
                let _diff_days = this.$tools.date.countDays( projInfo.end_date, undefined, projInfo.timezone )
                if ( Math.abs( _diff_days ) <= 30 ) _class += '-due'
                return _class
            },

            getProjectDevices(_projectID) {
                this.$store.dispatch('project/getProjectDevices', _projectID)
                    .then(res => {})
                    .catch(err => {})
            },

            getProjectMembers(_projectID) {
                this.$store.dispatch('project/getProjectMembers', _projectID)
                    .then(res => {})
                    .catch(err => {})
            },

        },
    }

</script>


<style lang="scss" scoped>
    .service-level {
        vertical-align: middle;
        margin-left: 10px;
        font-size: 1.2rem;
    }

    .block-service-level {
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
    }

    .header-align-btn {
        font-size: 1.3rem;
    }

    .area-cropperiod {
        margin-top: 30px;
    }

    .member-count {
        margin-right: 15px;
    }

    .member-normal {
        display: inline-block;
        margin-right: 0px;
        margin-left: 20px;
        // font-size: 0.9rem;

        i {
            margin-right: 0px !important;
        }
    }

    .member-admin {
        @extend .member-normal;
        color: #df6a6a;
    }

    .member-tooltip {
        text-align: left !important;
        padding-right: 10px;

        i {
            width: 25px;
            margin-right: 5px;
            text-align: center;
        }
    }

</style>
